import { render, staticRenderFns } from "./indexLocation.vue?vue&type=template&id=49be2aa2&scoped=true&"
import script from "./indexLocation.vue?vue&type=script&lang=js&"
export * from "./indexLocation.vue?vue&type=script&lang=js&"
import style0 from "./indexLocation.vue?vue&type=style&index=0&id=49be2aa2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be2aa2",
  null
  
)

component.options.__file = "indexLocation.vue"
export default component.exports